var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 30,
    viewBox: "0 0 107 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9819 23.705V0H19.4957V23.705H14.9819Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1207 15.1898C22.1207 13.4825 22.5208 11.9352 23.3211 10.548C24.1321 9.16082 25.2418 8.07774 26.6504 7.29878C28.0589 6.51982 29.6222 6.13034 31.3402 6.13034C33.0688 6.13034 34.6374 6.52515 36.046 7.31479C37.4545 8.09375 38.5589 9.17683 39.3592 10.564C40.1702 11.9405 40.5757 13.4825 40.5757 15.1898C40.5757 17.7828 39.706 19.9223 37.9667 21.6082C36.238 23.2942 34.0292 24.1372 31.3402 24.1372C28.6725 24.1372 26.469 23.2942 24.7296 21.6082C22.9903 19.9223 22.1207 17.7828 22.1207 15.1898ZM26.6504 15.1898C26.6504 16.641 27.0932 17.8308 27.9789 18.7591C28.8646 19.6768 29.985 20.1357 31.3402 20.1357C32.706 20.1357 33.8318 19.6768 34.7175 18.7591C35.6138 17.8308 36.062 16.641 36.062 15.1898C36.062 13.7279 35.6138 12.5221 34.7175 11.5724C33.8211 10.612 32.6953 10.1319 31.3402 10.1319C29.9743 10.1319 28.8485 10.6067 27.9629 11.5564C27.0879 12.5061 26.6504 13.7172 26.6504 15.1898Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6321 6.5625H46.562L49.5711 18.7271L52.8524 6.5625H57.11L60.3592 18.7271L63.4004 6.5625H68.3142L63.1763 23.705H58.1184L54.9812 12.7248L51.796 23.705H46.754L41.6321 6.5625Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9149 10.2279V6.5625H71.7396V2.96113H76.2053V6.5625H79.4065V10.2279H76.2053V16.8544C76.2053 18.0816 76.392 18.9032 76.7655 19.3194C77.1496 19.7248 77.8005 19.9276 78.7182 19.9276C79.0277 19.9276 79.3051 19.9169 79.5505 19.8956V23.7691C79.0917 23.8758 78.4461 23.9291 77.6138 23.9291C75.5864 23.9291 74.0924 23.3582 73.1321 22.2165C72.1824 21.0747 71.7075 19.33 71.7075 16.9825V10.2279H69.9149Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2396 23.705V0H86.7533V23.705H82.2396Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.318 6.5625L97.445 17.7348L95.3482 23.2729L92.9473 29.5793H97.2849L106.04 6.5625H101.318Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6038 6.5625H88.7539L95.3484 23.2729L97.4452 17.7348L93.6038 6.5625Z",
    fill: "#C4C7FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.705H4.62576V4.91382H0V23.705Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68162 14.4535L10.8523 10.324H4.62598V14.4535H9.68162Z",
    fill: "#C4C7FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7325 0.752319H0V4.9139H10.5617L11.7325 0.752319Z",
    fill: "#C4C7FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.d8482c123a89fc9f8ec0fc8a6a87745c.svg";
export { ForwardRef as ReactComponent };